import { render, staticRenderFns } from "./add-service-wizard-finish.vue?vue&type=template&id=c7c31724&scoped=true&"
import script from "./add-service-wizard-finish.js?vue&type=script&lang=js&"
export * from "./add-service-wizard-finish.js?vue&type=script&lang=js&"
import style0 from "./add-service-wizard-finish.css?vue&type=style&index=0&id=c7c31724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c31724",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardActions,VCardText})
